import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { isNil } from 'lodash';


const RenderLines = (props) => {
  let { mapReferenceThreed, lines } = props
  useEffect(() => {
    if (!mapReferenceThreed || typeof mapReferenceThreed.append !== 'function') {
      console.warn("Invalid mapReferenceThreed:", mapReferenceThreed);
      return;
    }

    if (mapReferenceThreed) {
      mapFunction();
    }
  }, [mapReferenceThreed, lines]); // ✅ Run only when mapReference is updated from undefined → defined


  async function mapFunction() {

    if (props.lines.length > 0) {
      const { Polyline3DElement, AltitudeMode } = await google.maps.importLibrary("maps3d");

      props?.lines?.forEach(line => {

        // Remove if already on the map
        line['measureType'] = 'line';

        const geoJson = line?.geoJson && JSON.parse(line.geoJson);
        const coords = geoJson?.features[0]?.geometry?.coordinates.map(coord => ({
          lat: coord[1],
          lng: coord[0],
          altitude: 100 // Set altitude here if needed
        }));

        // Color parsing with 3D compatibility
        let strokeColor = "#0009F9"; // default
        const rawColor = geoJson?.features[0]?.properties?.line?.color || "#0009F9";
        if (rawColor) {
          strokeColor = rawColor.length === 9
            ? "#" + rawColor.substring(3, 9)
            : rawColor.startsWith('#') ? rawColor : `#${rawColor}`;
        }

        // Create the 3D polyline
        const polyline3D = new Polyline3DElement({
          strokeColor,
          strokeWidth: 5,
          altitudeMode: "CLAMP_TO_GROUND",// "ABSOLUTE", // or "CLAMP_TO_GROUND" / "RELATIVE"
          extruded: true,
          drawsOccludedSegments: true,
        });

        polyline3D.coordinates = coords;
        // Append to the 3D map
        mapReferenceThreed.append(polyline3D);

        // Store reference
        line['mapObj'] = () => polyline3D;
      });
    }
  }

  return null;
}

const mapStateToProps = state => ({
  lines: state.lines,
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(RenderLines)

